(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useMemo } from "react";
import { useSelector } from "../../../store";
import { languageSelector } from "../state/selectors";
import i18nInstance from "../configs/i18n";

const useLanguage = () => {
  const language = useSelector(languageSelector);
  return useMemo(() => ({
    language,
    dir: i18nInstance.dir(language)
  }), [language]);
};

__signature__(useLanguage, "useSelector{language}\nuseMemo{}", () => [useSelector]);

const _default = useLanguage;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useLanguage, "useLanguage", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/hooks/useLanguage.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/hooks/useLanguage.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();